var exports = {
  "k": "xe533113f--fe7101--container",
};

module.exports = exports;
